import '../../../assets/img/flag-by.png';
import '../../../assets/img/flag-de.png';
import '../../../assets/img/flag-tr.png';
import '../../../assets/img/flag-ua.png';

import { Transition } from '@uirouter/core';
import { IDocumentService, IFormController, IWindowService } from 'angular';
import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import { LoginAttemptRejection } from '../../common/services/auth/auth.model';
import AuthService from '../../common/services/auth/auth.service';
import SecuredStorage from '../../common/services/local-storage/secured-storage.service';
import GlobalSpinnerService from '../../common/services/spinner/global-spinner.service';
import { UserResponse } from '../../common/services/user/user.model';
import UserService from '../../common/services/user/user.service';
import {
  CloseLoginDialogAction,
  McRequestedAction,
  OpenLoginDialogAction,
  OpenRegisterDialogAction
} from './login-dialog.action';
import loginSettings from './login-dialog.settings';

const storageKey = 'user-phonenumber';
const codeKey = 'user-phonecode';

/* @ngInject */
export default class LoginController implements ActionHandler {
  public loginPhoneCode;
  public phoneNumber: string;
  public password: string;
  public captcha: string;
  public captchaUrl: string;
  public rememberMe: boolean;
  public error: string;
  public phoneCodes;

  public territoryCode: string;
  public mobileConnection: boolean;
  public mcRequested: boolean;

  public dropDownState: boolean;
  private loginDialogElement: JQuery;
  private loginElement: JQuery;
  private registerElement: JQuery;
  private loginForm: IFormController;
  private transition: Transition;
  private redirectUrl: string;

  constructor(
    public config,
    private authService: AuthService,
    private $element,
    private $scope,
    private $state,
    private i18n,
    private actionDispatcher: ActionDispatcherService,
    private globalSpinner: GlobalSpinnerService,
    private securedStorage: SecuredStorage,
    private userService: UserService,
    private $document: IDocumentService,
    private $window: IWindowService
  ) {
    this.redirectUrl = this.config.auth.logout.redirect || '/';
    this.mobileConnection = this.config.mobileConnect.enabled || false;
  }

  public $onInit() {
    const closeFn = loginSettings.close;
    loginSettings.close = event => {
      if (angular.isFunction(closeFn)) {
        closeFn(event);
      }
      event.preventDefault();
      if (this.isOpened()) {
        this.closeDialog();
      }

      this.userService.isAuthenticated().then(authenticated => {
        if (!authenticated && this.isAuthAwareState()) {
          this.authService
            .logout()
            .finally(() => (this.$window.location.href = this.redirectUrl));
        }
      });
    };
  }

  public chooseCode(code) {
    this.loginPhoneCode = code;
    this.dropDownState = false;
  }

  public showDropDown() {
    this.dropDownState = !this.dropDownState;
  }

  public $postLink() {
    angular.element(() => {
      this.loginDialogElement = this.$element.find('#login-ui-dialog');
      this.loginElement = this.$element.find('.login');
      this.registerElement = this.$element.find('.register');
      this.loginForm = this.$scope.loginForm;
      this.loginDialogElement.dialog(loginSettings as any);
      this.actionDispatcher.register(this);
    });
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.loginDialogElement.dialog('destroy');
    this.$document
      .find('.ui-widget-overlay')
      .removeClass('login-dialog-overlay');
  }

  public handle(action: Action) {
    if (action instanceof OpenLoginDialogAction) {
      this.transition = action.transition;
      this.openDialog();
    }

    if (action instanceof CloseLoginDialogAction) {
      this.closeDialog();
    }

    if (action instanceof OpenRegisterDialogAction) {
      this.territoryCode = action.territoryCode;
      this.onRegister();
    }

    if (action instanceof McRequestedAction) {
      this.mcRequested = action.mcRequested;
    }
  }

  public onRegister() {
    this.registerElement.siblings('.active').removeClass('active'); // TODO: Rework in an Angular way.
    this.registerElement.addClass('active'); // TODO: Rework in an Angular way.
  }

  public activateMobileConnect(mobileConnect: boolean) {
    this.mobileConnection = mobileConnect;
  }

  public openDialog() {
    if (!this.isOpened()) {
      this.loginDialogElement.dialog('open');
      this.$document
        .find('.ui-widget-overlay')
        .addClass('login-dialog-overlay');
    }
  }

  public closeDialog() {
    this.loginDialogElement.dialog('close');
    this.$document
      .find('.ui-widget-overlay')
      .removeClass('login-dialog-overlay');
  }

  public isOpened() {
    return this.loginDialogElement.dialog('isOpen');
  }

  public onReset() {
    this.loginElement.siblings('.active').removeClass('active'); // TODO: Rework in an Angular way.
    this.loginElement.addClass('active'); // TODO: Rework in an Angular way.
  }

  public isSpinnerActivated() {
    return this.globalSpinner.isActivated();
  }

  private isAuthAwareState(): boolean {
    return this.$state.includes('login');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/login-dialog/login-dialog.controller.ts